/** Format API errors from POST /investments/redeem/ for investor UI. */
export function formatRedemptionApiError(err) {
  const status = err?.response?.status;
  const d = err?.response?.data;
  if (d == null) {
    if (status === 500) {
      return "The server could not process this redemption. Please try again or contact support if it continues.";
    }
    if (status === 403) return "You are not allowed to redeem shares for this project.";
    if (status === 404) return "Project not found.";
    return err?.message || "Redemption failed. Check your connection and try again.";
  }
  if (typeof d === "string" && d.trim()) return d.trim();
  if (typeof d.detail === "string") return d.detail;
  if (Array.isArray(d.detail) && d.detail[0]) return String(d.detail[0]);
  if (Array.isArray(d.detail)) {
    return d.detail.map((x) => (typeof x === "string" ? x : JSON.stringify(x))).join("; ");
  }
  if (typeof d === "object") {
    const parts = [];
    for (const [k, v] of Object.entries(d)) {
      if (Array.isArray(v)) {
        parts.push(`${k}: ${v.map((x) => (typeof x === "string" ? x : JSON.stringify(x))).join(", ")}`);
      } else if (typeof v === "string") {
        parts.push(`${k}: ${v}`);
      } else {
        parts.push(`${k}: ${JSON.stringify(v)}`);
      }
    }
    if (parts.length) return parts.join(" ");
  }
  return "Redemption failed.";
}
